import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class VerificationTimerService {
	private readonly RESEND_TIME_SEC = 60;

	private timerSub?: Subscription;
	private timeLeft$ = new BehaviorSubject<number>(0);
	public timeLeftObservable = this.timeLeft$.asObservable();

	public get isTimerActive(): boolean {
		return !!this.timerSub;
	}

	startTimer(): void {
		if (this.timerSub) {
			return;
		}

		this.timeLeft$.next(this.RESEND_TIME_SEC);

		this.timerSub = interval(1000).subscribe(() => {
			const timeLeftValue = this.timeLeft$.getValue();

			if (timeLeftValue > 0) {
				this.timeLeft$.next(timeLeftValue - 1);
			} else {
				this.timeLeft$.next(0);
				this.stopTimer();
			}
		});
	}

	stopTimer(): void {
		this.timerSub?.unsubscribe();
		this.timerSub = undefined;
	}
}
